import {doc} from './docs.js';
doc(
    "float32Array",
    {
        list: ""
    },
    "creates a Float32Array out of a list",
    undefined,
    {
        tags: "List"
    }
);

export const float32Array = (object) => {
    return ([list]) => {
        return [Float32Array.from(list)];
    };
};
